import WorksitesScreen from '@/features/worksites/components/worksites-screen';
import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import z from 'zod';

// FR-02 : la liste chantiers ne trie pas (CREATED_AT DESC fixé à l'écran,
// CH-15). L'URL porte la pagination, le filtre statut et la recherche
// (nom, référence, ville — maquette 2a). Statut absent = tous ; une valeur
// inconnue retombe sur « tous » plutôt qu'une erreur de route.
export const worksitesSearchSchema = z.object({
  search: fallback(z.string(), '').default(''),
  page: fallback(z.number(), 1).default(1),
  pageSize: fallback(z.number(), 20).default(20),
  status: fallback(
    z
      .enum([
        'DRAFT',
        'UPCOMING',
        'IN_PROGRESS',
        'ON_HOLD',
        'COMPLETED',
        'CANCELLED',
      ])
      .optional(),
    undefined,
  ).optional(),
});

export const Route = createFileRoute('/_app/worksites')({
  validateSearch: zodValidator(worksitesSearchSchema),
  component: WorksitesScreen,
});
